document.documentElement.classList.remove('no-js');

const closeMobileNavigation = () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav || nav.hidden) return;
  nav.hidden = true;
  toggle.setAttribute('aria-expanded', 'false');
  toggle.setAttribute('aria-label', 'Menü öffnen');
};

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    toggle.setAttribute('aria-label', open ? 'Menü öffnen' : 'Menü schließen');
    nav.hidden = open;
    if (!open) nav.querySelector('a')?.focus();
  }

  if (event.target.closest('[data-mobile-nav] a')) closeMobileNavigation();
  if (!event.target.closest('[data-mobile-nav], [data-menu-toggle]')) closeMobileNavigation();

});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  closeMobileNavigation();
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-sort-by]');
  if (!select) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', select.value);
  window.location.assign(url.toString());
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.selectedOptions[0];
  const form = select.closest('form');
  const button = form && form.querySelector('[data-add-to-cart]');
  const price = document.querySelector('[data-product-price] .price');
  const summary = document.querySelector('[data-variant-summary]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyButton = document.querySelector('[data-sticky-add]');
  const available = option && option.dataset.available === 'true';
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
  if (summary && option.dataset.title) summary.textContent = option.dataset.title;
  if (stickyButton) {
    stickyButton.disabled = !available;
    const stickyLabel = stickyButton.querySelector('[data-sticky-add-label]');
    if (stickyLabel) stickyLabel.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
  }
  if (button) {
    button.disabled = !available;
    const label = button.querySelector('[data-add-label]');
    if (label) label.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
    else button.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
  }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState({}, '', url);
});

// v5.4: mobile product gallery swipe indicators
const initProductGalleries = () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const wrap = gallery.closest('.product-gallery-wrap');
    const dots = wrap ? Array.from(wrap.querySelectorAll('[data-gallery-dot]')) : [];
    if (slides.length < 2) return;

    gallery.dataset.galleryReady = 'true';

    const setActiveDot = (index) => {
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    };

    const getClosestSlideIndex = () => {
      let closestIndex = 0;
      let closestDistance = Infinity;
      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - gallery.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    };

    let ticking = false;
    gallery.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setActiveDot(getClosestSlideIndex());
        ticking = false;
      });
    }, { passive: true });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        gallery.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      });
    });

    setActiveDot(0);
  });
};

document.addEventListener('DOMContentLoaded', initProductGalleries);
document.addEventListener('shopify:section:load', initProductGalleries);

// v5.5: compact quantity stepper on product pages
// Uses event delegation so it also works after Theme Editor section reloads.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-quantity-change]');
  if (!button) return;
  const stepper = button.closest('[data-quantity-stepper]');
  const input = stepper && stepper.querySelector('[data-quantity-input]');
  if (!input) return;
  const delta = Number(button.dataset.quantityChange || 0);
  const min = Number(input.min || 1);
  const max = input.max ? Number(input.max) : Infinity;
  const current = Number(input.value || min);
  input.value = String(Math.min(max, Math.max(min, current + delta)));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});


// v5.9: quantity steppers in the cart
// Quantity is submitted with the normal "Warenkorb aktualisieren" button.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-quantity-change]');
  if (!button) return;
  const stepper = button.closest('[data-cart-quantity-stepper]');
  const input = stepper && stepper.querySelector('[data-cart-quantity-input]');
  if (!input) return;
  const delta = Number(button.dataset.cartQuantityChange || 0);
  const min = Number(input.min || 0);
  const current = Number(input.value || 0);
  input.value = String(Math.max(min, current + delta));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});


// v5.11: mobile sticky purchase bar – only after the normal purchase card has scrolled past.
const initMobilePurchaseBars = () => {
  document.querySelectorAll('[data-mobile-purchase-bar]').forEach((bar) => {
    if (bar.dataset.stickyReady === 'true') return;
    const purchaseCard = document.querySelector('.product-purchase-card');
    if (!purchaseCard) return;
    bar.dataset.stickyReady = 'true';

    const updateVisibility = () => {
      const isMobile = window.matchMedia('(max-width: 640px)').matches;
      const hasPassedPurchase = purchaseCard.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', isMobile && hasPassedPurchase);
      bar.setAttribute('aria-hidden', String(!(isMobile && hasPassedPurchase)));
    };

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    updateVisibility();
  });
};

document.addEventListener('click', (event) => {
  const stickyAdd = event.target.closest('[data-sticky-add]');
  if (!stickyAdd) return;
  const mainAdd = document.querySelector('.product-purchase-card [data-add-to-cart]');
  if (!mainAdd || mainAdd.disabled) return;
  mainAdd.click();
});

document.addEventListener('DOMContentLoaded', initMobilePurchaseBars);
document.addEventListener('shopify:section:load', initMobilePurchaseBars);
